import { render, staticRenderFns } from "./CheckBag.vue?vue&type=template&id=3a71b300&scoped=true&"
import script from "./CheckBag.vue?vue&type=script&lang=js&"
export * from "./CheckBag.vue?vue&type=script&lang=js&"
import style0 from "./CheckBag.vue?vue&type=style&index=0&id=3a71b300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71b300",
  null
  
)

component.options.__file = "CheckBag.vue"
export default component.exports